export const formatDateString = (examDate: string | undefined, includeFinalT: boolean = false) => {
  if (!examDate) return '';
  
  const [day, month, year] = examDate.split('/').map(Number);

  const formattedDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}T00:00:00`;

  return includeFinalT ? `${formattedDate}T` : formattedDate;
};


  export const validBoolean = (value: boolean | undefined) => {
    if (value === undefined) return true
    return value
  }